export var IframeResizer;
(function (IframeResizer) {
    IframeResizer[IframeResizer["BetGames"] = 1] = "BetGames";
    IframeResizer[IframeResizer["BetRadar"] = 2] = "BetRadar";
    IframeResizer[IframeResizer["Evolution"] = 3] = "Evolution";
    IframeResizer[IframeResizer["IncentiveGames"] = 4] = "IncentiveGames";
    IframeResizer[IframeResizer["Kiron"] = 5] = "Kiron";
    IframeResizer[IframeResizer["GoldenRace"] = 6] = "GoldenRace";
    IframeResizer[IframeResizer["nsoft"] = 7] = "nsoft";
    IframeResizer[IframeResizer["TvBet"] = 8] = "TvBet";
    IframeResizer[IframeResizer["Authentic"] = 9] = "Authentic";
    IframeResizer[IframeResizer["Habanero"] = 10] = "Habanero";
})(IframeResizer || (IframeResizer = {}));
export const iframeResizer = new Map([
    [IframeResizer.BetGames, "BetGames"],
    [IframeResizer.BetRadar, "BetRadar"],
    [IframeResizer.Evolution, "Evolution"],
    [IframeResizer.GoldenRace, "GoldenRace"],
    [IframeResizer.IncentiveGames, "IncentiveGames"],
    [IframeResizer.Kiron, "Kiron"],
    [IframeResizer.nsoft, "nsoft"],
    [IframeResizer.TvBet, "TvBet"],
    [IframeResizer.Authentic, "Authentic"],
    [IframeResizer.Habanero, "Habanero"],
]);
